var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvoice({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6667 7.22222H9.33333M15.6667 11.4444H9.33333M15.6667 15.6667H11.4444M5.11111 3H19.8889V22L18.7996 21.0669C18.4169 20.739 17.9297 20.5587 17.4258 20.5587C16.9218 20.5587 16.4346 20.739 16.0519 21.0669L14.9626 22L13.8743 21.0669C13.4916 20.7387 13.0041 20.5583 12.5 20.5583C11.9959 20.5583 11.5084 20.7387 11.1257 21.0669L10.0374 22L8.94806 21.0669C8.56544 20.739 8.07816 20.5587 7.57425 20.5587C7.07034 20.5587 6.58306 20.739 6.20044 21.0669L5.11111 22V3Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvoice);
export default __webpack_public_path__ + "static/media/invoice.17d844c8b59eb5630ae119a588348088.svg";
export { ForwardRef as ReactComponent };